import {
    ChangeDetectionStrategy,
    Component,
    computed,
    input,
} from '@angular/core';
import { WorkflowStateBadgeComponent } from '@interacta-shared/ui-common';
import { IconComponent } from '@interacta-shared/ui-icons';
import { UserNotificationEvent } from '@modules/notification/models/user-notification.model';
import { UserNotificationComponent } from '../user-notification/user-notification.component';

@Component({
    selector: 'interacta-change-status-notification',
    imports: [
        UserNotificationComponent,
        WorkflowStateBadgeComponent,
        IconComponent,
    ],
    templateUrl: './change-status-notification.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChangeStatusNotificationComponent {
    notification = input.required<UserNotificationEvent>();

    readonly fromState = computed(() =>
        this.notification().aggregated
            ? this.notification().firstPostWorkflowOperationDetail?.fromState
            : this.notification().lastPostWorkflowOperationDetail?.fromState,
    );
    readonly toState = computed(
        () => this.notification().lastPostWorkflowOperationDetail?.toState,
    );
}
